module.exports = __webpack_public_path__ + "static/media/infiniti-plus.20336057.svg";